<template>
	<v-dialog
		ref="dialog"
		v-model="modal"
		:return-value.sync="date"
		persistent
		lazy
		full-width
		width="290px"
	>
		<template v-slot:activator="{ on }">
			<v-text-field
				class="ml-2"
				v-model="date"
				label="Beschäftigungsbeginn"
				append-icon="event"
				readonly
				v-on="on"
			></v-text-field>
		</template>
		<v-date-picker
			v-model="date"
			type="month"
			first-day-of-week="1"
			locale="de-DE"
			no-title
		>
			<v-spacer></v-spacer>
			<v-btn flat color="primary" @click="modal = false">Abbrechen</v-btn>
			<v-btn flat color="primary" @click="save()">OK</v-btn>
		</v-date-picker>
	</v-dialog>
</template>

<script>
import * as moment from 'moment';
import { mapState } from 'vuex';

export default {
	computed: {
		...mapState({
			initialDate: state => state.commicement,
		}),
	},
	methods: {
		save() {
			this.$refs.dialog.save(this.date);

			const inputDate = moment(this.date);
			const commicementgt6months = moment().diff(inputDate, 'months') > 6;

			this.$store.dispatch('setCommicement', {
				date: this.date,
				commicementgt6months,
				before2004: inputDate.isBefore('2004-01-01', 'month'),
			});

			this.$emit('save', commicementgt6months);
		},
	},
	created() {
		this.date = this.initialDate;
	},
	data: () => ({
		date: null,
		modal: false,
	}),
};
</script>
